import useSearchResults from "@SearchResults/hooks/useSearchResults";
import getSearchResultsCountPerType from "@SearchResults/functions/getSearchResultsCountPerType";

export default function useSearchResultsCountPerType(includeUnavailable = true) {
    const searchResults = useSearchResults()

    return getSearchResultsCountPerType(searchResults.data, includeUnavailable)
}